import React from 'react';
import { Button } from './ui/Button';
import { SectionLabel } from './ui/SectionLabel';
import { useLanguage } from '../contexts/LanguageContext';

export const Hero: React.FC = () => {
  const { t } = useLanguage();

  const handleScheduleClick = () => {
    document.getElementById('audit')?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section className="relative w-full min-h-screen flex flex-col justify-center px-6 pt-20 max-w-7xl mx-auto border-x border-white/5">
      <div className="max-w-4xl">
        <SectionLabel text={t.hero.label} />
        
        <h2 className="text-5xl md:text-7xl lg:text-8xl font-light text-white tracking-tight leading-[1.1] mb-8">
          {t.hero.title.split('\n').map((line, index) => (
            <React.Fragment key={index}>
              {index > 0 && <br />}
              <span className={index > 0 ? "text-zinc-500" : "text-white"}>
                {line}
              </span>
            </React.Fragment>
          ))}
        </h2>
        
        <p className="max-w-xl text-lg md:text-xl leading-relaxed font-light text-mutedGray mb-12">
          {t.hero.subtitle}
        </p>

        <div className="flex flex-col sm:flex-row gap-6 items-start sm:items-center">
          <Button onClick={handleScheduleClick}>
            {t.hero.cta}
          </Button>
          
          <div className="flex items-center gap-4 text-xs font-mono text-zinc-500">
            <span>{t.hero.status1}</span>
            <span>{t.hero.status2}</span>
          </div>
        </div>
      </div>

      <div className="absolute bottom-10 right-6 hidden lg:block">
        <div className="border border-white/10 p-4 w-64 backdrop-blur-sm">
          <div className="flex justify-between items-center mb-2">
            <span className="font-mono text-xs text-mutedGray">{t.hero.active_agents}</span>
            <span className="font-mono text-xs text-emerald">{t.hero.running}</span>
          </div>
          <div className="space-y-1">
            <div className="h-px w-full bg-white/10 overflow-hidden">
                <div className="h-full bg-emerald w-2/3 animate-pulse"></div>
            </div>
            <div className="flex justify-between text-[10px] font-mono text-zinc-600">
              <span>{t.hero.workflow}</span>
              <span>{t.hero.uptime}</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};